var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteOmlyclo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.031,
    height: 57.047,
    viewBox: "0 0 38.031 57.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M0,0H38.031V-57.047H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 57.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(31.117 -49.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M0,0H4.317a2.592,2.592,0,0,1,2.6,2.6V46.669a2.6,2.6,0,0,1-2.6,2.6H-28.519a2.592,2.592,0,0,1-2.6-2.6V2.6a2.592,2.592,0,0,1,2.6-2.6H-24.2V-1.729a2.588,2.588,0,0,1,2.591-2.593h4.568A6.4,6.4,0,0,1-16.25-5.7,4.985,4.985,0,0,1-12.1-7.779,4.987,4.987,0,0,1-7.952-5.7,6.387,6.387,0,0,1-7.16-4.322h4.568A2.589,2.589,0,0,1,0-1.729ZM-22.473-1.729V3.459a.864.864,0,0,0,.862.863H-2.59a.863.863,0,0,0,.861-.863V-1.729a.859.859,0,0,0-.862-.864H-7.779a.864.864,0,0,1-.838-.655,3.462,3.462,0,0,0-.149-.417,4.66,4.66,0,0,0-.569-1A3.271,3.271,0,0,0-12.1-6.051a3.272,3.272,0,0,0-2.766,1.383,4.655,4.655,0,0,0-.568,1,3.287,3.287,0,0,0-.149.417.864.864,0,0,1-.838.655H-21.61A.86.86,0,0,0-22.473-1.729ZM-24.2,1.729h-4.316a.864.864,0,0,0-.87.87v44.07a.863.863,0,0,0,.869.87H4.317a.87.87,0,0,0,.869-.87V2.6a.863.863,0,0,0-.869-.87H0v1.73A2.592,2.592,0,0,1-2.59,6.051H-21.611A2.594,2.594,0,0,1-24.2,3.459Zm1.476,13.218,1.117,1.118,2.847-2.847a.865.865,0,0,1,1.222,0,.866.866,0,0,1,0,1.223L-21,17.9a.863.863,0,0,1-1.222,0l-1.729-1.729a.865.865,0,0,1,0-1.222A.866.866,0,0,1-22.726,14.947Zm0,10.372,1.117,1.118,2.847-2.847a.865.865,0,0,1,1.222,0,.866.866,0,0,1,0,1.223L-21,28.27a.863.863,0,0,1-1.222,0l-1.729-1.728a.866.866,0,0,1,0-1.223.864.864,0,0,1,1.223,0m0,10.372,1.117,1.118,2.847-2.846a.863.863,0,0,1,1.222,0,.865.865,0,0,1,0,1.222L-21,38.642a.863.863,0,0,1-1.222,0l-1.729-1.728a.865.865,0,0,1,0-1.222.864.864,0,0,1,1.223,0Z",
    fill: "#67abe4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(16.204 -33.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M0,0H16.08M0,9.245H16.08M0,19.185H16.08",
    fill: "none",
    stroke: "#662d91",
    strokeLinecap: "round",
    strokeWidth: 1.167
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteOmlyclo);
export default __webpack_public_path__ + "static/media/note-omlyclo.ce65e85ebe049341f5faac9bbeaf952b.svg";
export { ForwardRef as ReactComponent };